<template>
    <div v-on:click="connectWalletHandler" class="connect-wallet-btn-mobile" v-bind:class="{'connect-wallet-btn-mobile--disabled': !walletLoaded}">
        <span v-if="!walletLoaded">
            {{ $t('tonconnect.loading') }}
        </span>
        <template v-else>
            <template v-if="walletName"><wallet-icon />{{ walletName }}</template>
            <span v-else>{{ $t('tonconnect.connect_wallet') }}</span>
        </template>
    </div>
</template>

<script>
import WalletIcon from '@img/icons/tonscan/wallet.svg?inline';
import { THEME } from '@tonconnect/ui';
import { Address } from '~/tonweb';
import { getDomainByAddress } from '~/api/toncenterV3';

export default {
    data() {
        return {
            openDropdown: false,
            walletName: null,
            walletLoaded: false,
            unsubscribe: null,
        };
    },

    mounted() {
        this.loadWallet();
    },

    methods: {
        loadWallet() {
            this.$tonConnect.connectionRestored.then((restored) => {
                if (restored) {
                    this.updateAddress();
                } else {
                    this.walletLoaded = true;
                }
            });

            this.unsubscribe = this.$tonConnect.onStatusChange((wallet) => {
                if (!wallet) {
                    // Кошелёк отключили где угодно
                    this.walletName = null;
                    this.walletLoaded = true; // кнопка активна
                    return;
                }

                this.updateAddress();
            });
        },
        async connectWalletHandler() {
            if (!this.$tonConnect.connected) {
                // Open connect modal
                await this.$tonConnect.openModal();

                this.$tonConnect.uiOptions = {
                    language: this.$store.state.appLocale,
                    uiPreferences: {
                        theme: this.$store.state.appTheme === 'light' ? THEME.LIGHT : THEME.DARK,
                    },
                };
            } else {
                // Open dropdown for the connected wallet
                this.$emit('toggle-wallet-dropdown');
            }
        },

        async updateAddress() {
            const addressRaw = this.$tonConnect.wallet?.account?.address;

            if (!addressRaw) return;

            const address = new Address(addressRaw).toString({
                userFriendly: true,
                bouncable: false,
                testOnly: false,
            });

            const domain = await getDomainByAddress(address);
            this.walletLoaded = true;

            if (domain) {
                this.walletName = domain.length > 15
                    ? domain.slice(0, 6) + '...' + domain.slice(-6)
                    : domain;
                return;
            }

            this.walletName = address.slice(0, 4) + '...' + address.slice(-4);
        },
    },

    beforeDestroy() {
        if (this.unsubscribe) this.unsubscribe();
    },

    components: {
        WalletIcon,
    },
};
</script>

<style scoped lang="scss">
.connect-wallet-btn-mobile {
    width: 100%;
    cursor: pointer;
    user-select: none;
    color: white;
    background-color: var(--big-blue-button-background);
    border-radius: 12px;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    margin-bottom: 12px;
    gap: 8px;

    &--disabled {
        opacity: .6;
        cursor: default;
        pointer-events: none;
    }

    &:hover,
    &:active {
        background-color: var(--big-blue-button-hover-background);
    }

    svg {
        width: 16px;
        height: 16px;
    }
}
</style>
